import { Routes, RouterModule } from '@angular/router';
import { ConfirmEmailComponent } from 'src/app/account/confirmEmail/confirmEmail.component';
import { ConfirmEmailSentInfoComponent } from 'src/app/account/confirmEmail/Info-confirm-email-email-sent.component';
import { ForgotComponent } from 'src/app/account/forgotPassword/forgot.password.component';
import { LoginFormComponent } from 'src/app/account/login/login.component';
import { BusinessRegisterComponent } from 'src/app/account/register/business-register.component';
import { RegisterComponent } from 'src/app/account/register/register.component';
import { ResetPasswordComponent } from 'src/app/account/resetPassword/reset-password.component';
import { HomeComponent } from 'src/app/home/home.component';
import { ManageBookingComponent } from 'src/app/manage-booking/manage-booking.component';
import { AuthGuard } from './auth.guard';
import { UserType } from '@core/interfaces';
import { AboutComponent } from '@app/footer/footer-components/about.component';
import { HomeGuard } from './home.guard';
import { ExternalAuthCallbackComponent } from 'src/app/account/external-auth/external-auth-callback.component';
import { DataProtectionComponent } from '@app/footer/data-protection/data-protection.component';
import { TermsAndConditionsComponent } from '@app/footer/terms-and-conditions/terms-and-conditions.component';
import { FeaturesComponent } from '@app/footer/features/features.component';
import { ContactComponent } from '@app/footer/contact/contact.component';
import { BUSINESS_ROUTE } from '@core/configs/route-paths';




const routes: Routes = [
  {
    path: '',
    component: HomeComponent,
    pathMatch: 'full',
    canActivate: [HomeGuard],
    data: { role: UserType.Customer }
  },
  {
    path: 'business-services',
    loadChildren: () => import('../app/business-services/business-services.module').then(m => m.BusinessServicesModule),
  },
  { path: 'sign-up', component: RegisterComponent, data:{title:'sign-up'} },
  { path: 'sign-up-business', component: BusinessRegisterComponent, data:{title:'sign-up-business'} },
  { path: 'sign-in', component: LoginFormComponent, data:{title:'sign-in'} },
  { path: 'external-auth', component: ExternalAuthCallbackComponent, data:{title:'external-auth'} },
  { path: 'forgot-password', component: ForgotComponent,  data:{title:'forgot-password'} },
  { path: 'reset-password', 
  component: ResetPasswordComponent,
      data:{title:'reset-password'}
},
  {
    path: 'confirm-email',
    component: ConfirmEmailComponent
    // canActivate: [AuthGuard],
    // data: { roles: [Role.Admin] }
  },
  {
    // Linked from booking emails; the token identifies the booking.
    path: 'appointments/:token',
    component: ManageBookingComponent,
    data: { title: 'manage-booking' }
  },
  {
    path: 'info-confirm-email',
    component: ConfirmEmailSentInfoComponent
    // canActivate: [AuthGuard],
    // data: { roles: [Role.Admin] }
  },
  {
    path: 'profile',
    loadChildren: () => import('../app/profile/profile.module').then(m => m.ProfileModule),
    canActivate: [AuthGuard],
    data: { role: UserType.Customer }
  },
  {
    path: BUSINESS_ROUTE,
    loadChildren: () => import('../app/b-profile/b-profile.module').then(m => m.BProfileModule),
    canMatch: [AuthGuard],
    canActivate: [AuthGuard],
    canActivateChild: [AuthGuard],
    data: {
      role: UserType.Business,
    }
  },
  {
    path: 'about',
    component: AboutComponent,
    data:{title:"about"}
  },
  {
    path: 'features',
    component: FeaturesComponent,
    data:{title:'features'}
  },
  {
    path: 'terms-and-conditions',
    component: TermsAndConditionsComponent,
    data:{title:'terms-and-conditions'}
  },
  {
    path: 'data-protection',
    component: DataProtectionComponent,
    data:{title:'data-protection'}
  },
  {
    path: 'contact',
    component: ContactComponent,
    data:{title:'contact'}
  },
  // otherwise redirect to home
  { path: '**', redirectTo: '' }
];

export const appRoutingModule = RouterModule.forRoot(routes, {
  scrollPositionRestoration: 'top',
});
